module.exports = {
    apiUrl: process.env.NODE_ENV === 'production'
      ? 'https://epa.culturalcenter.gov.ph'
      : process.env.NODE_ENV === 'development'
        ? 'http://localhost:8000'
        : 'http://epa-beta.zennerslab.com:8080'  // staging site
  }